import React from 'react';
import Box from '@mui/material/Box';

import BattleBalanceBar from '../../BattleBalanceBar';
import { buildBetDisplayItems } from '../../betLabels';
import MemberMyBetSummary from './MemberMyBetSummary';

const RESPONSIVE_MODE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

const DEFAULT_MESSAGE_BY_RESPONSIVE_MODE = {
  [RESPONSIVE_MODE.MOBILE]: 'ベットタイムが終了しました。結果の登録を待っています。',
  [RESPONSIVE_MODE.DESKTOP]: 'ベットタイムが終了しました。結果の登録を待っています。',
};

const pcMessageSx = {
  p: 2,
  borderRadius: '18px',
  background: 'linear-gradient(135deg, rgba(254, 243, 199, 0.95) 0%, rgba(255, 251, 235, 0.95) 100%)',
  border: '1px solid rgba(245, 158, 11, 0.28)',
  boxShadow: '0 10px 24px rgba(146, 64, 14, 0.08)',
  color: 'rgba(120, 53, 15, 0.95)',
  fontSize: '15px',
  fontWeight: 800,
  lineHeight: 1.7,
  whiteSpace: 'pre-line',
};

const spMessageSx = {
  px: 1.25,
  py: 1,
  borderRadius: '12px',
  background: 'rgba(255, 251, 235, 0.96)',
  border: '1px solid rgba(245, 158, 11, 0.22)',
  boxShadow: '0 4px 12px rgba(146, 64, 14, 0.06)',
  color: 'rgba(120, 53, 15, 0.92)',
  fontSize: '13px',
  fontWeight: 800,
  lineHeight: 1.55,
  whiteSpace: 'pre-line',
};

function FinishContentLayout({
  choices = [],
  expectedPayouts = [],
  highlightedBetSelections = [],
  loadingMyBet = false,
  message,
  responsiveMode,
  summaryData,
}) {
  const isMobile = responsiveMode === RESPONSIVE_MODE.MOBILE;
  const displayMessage = message
    ?? DEFAULT_MESSAGE_BY_RESPONSIVE_MODE[responsiveMode]
    ?? DEFAULT_MESSAGE_BY_RESPONSIVE_MODE[RESPONSIVE_MODE.DESKTOP];
  const battleBalanceDisplayLabels = isMobile
    ? buildBetDisplayItems(choices).map((item) => item.label)
    : [];

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 680,
        mx: 'auto',
        px: { xs: 1.5, sm: 2 },
        py: { xs: 2, sm: 3 },
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {isMobile ? (
          <Box sx={spMessageSx}>{displayMessage}</Box>
        ) : (
          <Box sx={pcMessageSx}>{displayMessage}</Box>
        )}

        <MemberMyBetSummary
          choices={choices}
          expectedPayouts={expectedPayouts}
          loading={loadingMyBet}
        />

        <BattleBalanceBar
          choices={choices}
          compact={isMobile}
          displayLabels={battleBalanceDisplayLabels}
          highlightedSelections={highlightedBetSelections}
          summaryData={summaryData}
        />

      </Box>
    </Box>
  );
}

export default FinishContentLayout;
